// extracted by mini-css-extract-plugin
module.exports = {"card":"ViewPosts_card__1xRoT","background":"ViewPosts_background__eLz4O","gradient":"ViewPosts_gradient__hzpYF"};